import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  AppButton,
  AppCard,
  AppCardBody,
  AppCardHeader,
  AppPage,
  AppPageIntro,
  AppSectionHeader,
} from '../../ui-foundation';

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname);
  }, [location.pathname]);

  return (
    <AppPage className="animate-fade-in">
      <AppPageIntro title="Page not found" subtitle="That route does not exist or is no longer available." />

      <AppCard alignItems="center" className="text-center">
        <AppCardHeader alignItems="center">
          <AppSectionHeader
            title="404"
            subtitle="We could not find the page you were trying to open."
            align="center"
          />
        </AppCardHeader>
        <AppCardBody alignItems="center">
          <div className="max-w-md space-y-4">
            <p className="text-sm leading-relaxed text-muted-foreground">
              Try going back to the landing page and navigating from there.
            </p>
            <AppButton size="sm" onPress={() => navigate('/')}>
              Return to Home
            </AppButton>
          </div>
        </AppCardBody>
      </AppCard>
    </AppPage>
  );
};

export default NotFound;
